import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import CtaButton from '../ctaButton/ctaButton';
import styles from './legService.module.scss';

export default function LegService({ agreementType }) {
  const [legUrlData, setLegUrlData] = useState('');
  const [contentRef, setContentRef] = useState(null);
  const mountNode = contentRef?.contentWindow?.document?.body;
  useEffect(() => {
    if (agreementType) {
      fetch('/api/leg-service', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          agreementType,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setLegUrlData(data.html);
        })
        .catch(() => {
          setLegUrlData('');
        });
    }
  }, [agreementType]);

  const handleClick = () => {
    mountNode.focus();
    contentRef.contentWindow.print();
  };

  return (
    <div className={styles.legContainer}>
      {legUrlData && (
        <>
          <CtaButton
            label="Download PDF"
            id="leg-pdf-button"
            onClick={handleClick}
            data-testid="leg-pdf"
            type="button"
            aria-label="PDF Button"
          />
          <div className={styles.legFrameContainer}>
            <iframe
              title="LegFrame"
              width="100%"
              allowFullScreen
              className={styles.legFrame}
              data-testid="leg-iframe"
              ref={setContentRef}
            >
              {mountNode && createPortal(parse(legUrlData), mountNode)}
            </iframe>
          </div>
        </>
      )}
    </div>
  );
}

LegService.propTypes = {
  agreementType: PropTypes.string,
};
